var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 395.06 395.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f6bdac;}.cls-2{fill:#c2968b;}.cls-3{fill:#daa79d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_copy",
    "data-name": "Layer 2 copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.52,298.67A100.7,100.7,0,1,1,299.21,198,100.81,100.81,0,0,1,198.52,298.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 188,
    y: 323.15,
    width: 19.05,
    height: 71.92,
    rx: 9.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 302.25,
    y: 275.82,
    width: 19.05,
    height: 71.92,
    rx: 9.53,
    transform: "translate(-129.14 311.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 323.15,
    y: 188,
    width: 71.92,
    height: 19.05,
    rx: 9.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 275.82,
    y: 73.75,
    width: 71.92,
    height: 19.05,
    rx: 9.53,
    transform: "translate(32.43 244.86) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 188,
    width: 19.05,
    height: 71.92,
    rx: 9.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73.75,
    y: 47.32,
    width: 19.05,
    height: 71.92,
    rx: 9.53,
    transform: "translate(-34.5 83.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 188,
    width: 71.92,
    height: 19.05,
    rx: 9.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.32,
    y: 302.25,
    width: 71.92,
    height: 19.05,
    rx: 9.53,
    transform: "translate(-196.07 150.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.53,298.06a100.7,100.7,0,1,1,100.7-100.7A100.81,100.81,0,0,1,197.53,298.06Zm0-183.39a82.7,82.7,0,1,0,82.7,82.69A82.78,82.78,0,0,0,197.53,114.67Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.100d2418568651701a5e1df403491de7.svg";
export { ForwardRef as ReactComponent };